export const formatBigNumber = (value: number | string | null | undefined) => {
  const num = parseFloat((value ?? '').toString().replace(/\s+/g, ''));

  if (isNaN(num) || !num) return 0;

  const format = (divisor: number, suffix: string) =>
    (num / divisor).toFixed(1).replace(/\.0$/, '') + suffix;

  if (num >= 1_000_000) return format(1_000_000, 'M');
  if (num >= 1_000) return format(1_000, 'K');

  return num;
};
